export const services = [
  {
    id: 1,
    key: 'personalStatusCourts',
    icon: 'Heart',
  },
  {
    id: 2,
    key: 'criminalCourts',
    icon: 'Shield',
  },
  {
    id: 3,
    key: 'civilCourts',
    icon: 'Scale',
  },
  {
    id: 4,
    key: 'administrativeCases',
    icon: 'Briefcase',
  },
  {
    id: 5,
    key: 'enforcementJudgments',
    icon: 'Gavel',
  },
  {
    id: 6,
    key: 'contractsConsultancy',
    icon: 'FileText',
  },
  {
    id: 7,
    key: 'companies',
    icon: 'Building',
  },
  {
    id: 8,
    key: 'bankingServices',
    icon: 'Landmark',
  },
  {
    id: 9,
    key: 'residencyForeigners',
    icon: 'Globe',
  },
  {
    id: 10,
    key: 'realEstateRegistration',
    icon: 'Building2',
  },
  {
    id: 11,
    key: 'investment',
    icon: 'TrendingUp',
  },
  {
    id: 12,
    key: 'taxServices',
    icon: 'Calculator',
  },
];

export const teamMembers = [
  {
    id: 1,
    name: 'RAZBAN QANI SMAEL',
    nameAr: 'رزبان قانع سمایل',
    nameKu: 'رزبان قانع سمایل',
    position: 'seniorLegalConsultant',
    image: '/bzhar.jpg?v=30',
    size: 'large',
    bioEn: `Authorized Managing Director of the Company:
Advocate Razban Qani Smail
Born in (1977) – Erbil.
Holds a Bachelor's Degree in Law (2003).
Member of the Kurdistan Lawyers Syndicate since (2003).
Has (24) years of experience in the practice of advocacy before all courts, working with governmental and non-governmental institutions and bodies, and providing legal consultancy services to companies.`,
    bioAr: `المدير المفوض للشركة: المحامي رزبان قانع سمايل
مواليد عام (1977) – أربيل.
حاصل على شهادة البكالوريوس في القانون عام (2003).
عضو في نقابة محامي كوردستان منذ عام (2003).
يمتلك خبرة تمتد إلى (24) عامًا في ممارسة مهنة المحاماة أمام جميع المحاكم، والعمل مع المؤسسات والدوائر الحكومية وغير الحكومية، وتقديم الاستشارات القانونية للشركات.
رقم الهاتف: 07504459836`,
    bioKu: `بەرێوەبەرى رێپێدراوى کۆمپانیا: پارێزەر رزبان قانع سمایل
لە دایک بووى (1977) – (هەولێر).
خاوەنى بڕوانامەى بەکالۆریۆس لە یاسا ساڵى (2003).
ئەندامى سەندیکاى پارێزەرانى کوردستان لە ساڵى (2003) وە.
خاوەنى ئەزموونى (24) ساڵ کارى پارێزەرایەتى لە گشت دادگاکان و دام و دەزگا حکومى و ناحکومییەکان و ڕاوێژکارى یاسایی کۆمپانیاکان.
ژ. م. 07504459836`,
    phone: '07504459836',
  },
  {
    id: 2,
    name: 'EMAN EZZALDIN BAKR',
    nameAr: 'ایمان عزالدین بکر',
    nameKu: 'ایمان عزالدین بکر',
    position: 'seniorLegalConsultantFemale',
    image: '',
    size: 'medium',
    bioEn: `Consulting Advocate: Eman Ezzaldin Bakr
Born in (1991) – Erbil.
Holds a Bachelor's Degree in Law (2014).
Holds a Master's Degree in Law, specializing in Public Law (2023).
PhD Candidate in Public Law, specializing in Financial Law, admitted for the academic year (2023–2024).
Assistant Lecturer at the College of Law in the City of Erbil.
Member of the Kurdistan Lawyers Syndicate since (2014).
Has (12) years of experience in the practice of advocacy before all courts, working with governmental and non-governmental institutions and bodies, and providing legal consultancy services.
Mobile: 07504905677`,
    bioAr: `المحامية المستشارة: ايمان عز الدين بكر
مواليد عام (1991) – أربيل.
حاصلة على شهادة البكالوريوس في القانون عام (2014).
حاصلة على شهادة الماجستير في القانون – تخصص القانون العام عام (2023).
طالبة دكتوراه في القانون العام – تخصص القانون المالي، ومقبولة للعام الدراسي (2023–2024).
مدرس مساعد في كلية القانون بمدينة أربيل.
عضو في نقابة محامي كوردستان منذ عام (2014).
تمتلك خبرة تمتد إلى (12) عامًا في ممارسة مهنة المحاماة أمام جميع المحاكم، والعمل مع المؤسسات والدوائر الحكومية وغير الحكومية، وتقديم الاستشارات القانونية.
رقم الهاتف: 07504905677`,
    bioKu: `پارێزەرى ڕاوێژکار: (ایمان عزالدین بکر)
لە دایک بووى (1991) – (هەولێر).
خاوەنى بڕوانامەى بەکالۆریۆس لە یاسا ساڵى (2014).
خاوەنى بڕوانامەى ماستەر لە یاسا - پسپۆڕى یاساى گشتى ساڵى (2023).
خوێندکارى دکتۆرا لە یاساى گشتى – پسپۆڕى یاساى دارایی، وەرگیراوى ساڵى خوێندنى (2023 – 2024).
مامۆستاى یاریدەدەر لە کۆلێژى یاسا لە شارى هەولێر.
ئەندامى سەندیکاى پارێزەرانى کوردستان لە ساڵى (2014) وە.
خاوەنى ئەزموونى (12) ساڵ کارى پارێزەرایەتى لە گشت دادگاکان و دام و دەزگا حکومى و ناحکومییەکان و ڕاوێژکارى یاسایی.
ژ. م. 07504905677`,
    phone: '07504905677',
  },
  {
    id: 3,
    name: 'BZHAR OMAR MUHAMMED',
    nameAr: 'بژار عمر محمد',
    nameKu: 'بژار عمر محمد',
    position: 'seniorLegalConsultant',
    image: '/razban.jpg',
    size: 'medium',
    bioEn: `Consulting Advocate: Bzhar Omar Mohammed
Born in (1988) – Erbil.
Holds a Bachelor's Degree in Law (2013).
Member of the Kurdistan Lawyers Syndicate since (2013).
Has (13) years of experience in the practice of advocacy before all courts, working with governmental and non-governmental institutions and bodies, and providing legal consultancy services.
Mobile: 07504649399`,
    bioAr: `المحامي المستشار: بژار عمر محمد
مواليد عام (1988) – أربيل.
حاصل على شهادة البكالوريوس في القانون عام (2013).
عضو في نقابة محامي كوردستان منذ عام (2013).
يمتلك خبرة تمتد إلى (13) عامًا في ممارسة مهنة المحاماة أمام جميع المحاكم، والعمل مع المؤسسات والدوائر الحكومية وغير الحكومية، وتقديم الاستشارات القانونية.
رقم الهاتف: 07504649399`,
    bioKu: `پارێزەرى ڕاوێژکار: (بژار عمر محمد)
لە دایک بووى (1988) – (هەولێر).
خاوەنى بڕوانامەى بەکالۆریۆس لە یاسا ساڵى (2013).
ئەندامى سەندیکاى پارێزەرانى کوردستان لە ساڵى (2013) وە.
خاوەنى ئەزموونى (13) ساڵ کارى پارێزەرایەتى لە گشت دادگاکان و دام و دەزگا حکومى و ناحکومییەکان و ڕاوێژکارى یاسایی.
ژ. م. 07504649399`,
    phone: '07504649399',
  },
];

export const stats = [
  { id: 1, value: '24+', labelKey: 'yearsInLaw', icon: 'Briefcase' },
  { id: 2, value: '10+', labelKey: 'internationalTeam', icon: 'Globe' },
  { id: 3, value: '95%', labelKey: 'casesWon', icon: 'Award' },
  { id: 4, value: '200+', labelKey: 'partners', icon: 'Users' },
  { id: 5, value: '1000+', labelKey: 'satisfiedClients', icon: 'UserCheck' },
  { id: 6, value: '24/7', labelKey: 'comprehensiveSupport', icon: 'HeadphonesIcon' },
];

export const successRates = [
  { id: 1, service: 'familyLaw', rate: 98 },
  { id: 2, service: 'debtCollection', rate: 97 },
  { id: 3, service: 'criminalLaw', rate: 96 },
  { id: 4, service: 'commercialLaw', rate: 98 },
  { id: 5, service: 'realEstateLaw', rate: 99 },
  { id: 6, service: 'legalAdvisory', rate: 97 },
];

export const contactInfo = {
  phones: ['07512044000', '07752044000'],
  email: 'nobleelawfirm@gmail.com',
  mainAddress: 'Iraq, Erbil',
  officeAddress: 'Minara Choli, Opposite Zagros Bank & Qallat Bank',
  whatsapp: '9647512044000',
};
